import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useRouter } from "next/router";
import { useForm } from "react-hook-form";

import ScheduleDiscountEditor from "../../components/discount/scheduleDiscountEditor";
import Layout from "../../components/layouts/layout.comp";
import discountCore from "../../core/discount.core";
import { useTranslation } from "../../core/translation.core";
import { DiscountFormData } from "../../types/discount";

export default function ScheduleDiscountCreatePage() {
  const { t, msg } = useTranslation();
  const methods = useForm<DiscountFormData>({
    mode: "onTouched",
    defaultValues: {
      placementRestriction: {
        type: "inclusion",
        restrictToEshop: true,
        restrictToRetailIds: [],
      },
      productRestriction: { type: "none", restrictToIds: [] },
      categoryRestriction: { type: "none", restrictToIds: [] },
      shipOptionRestriction: { type: "none", restrictToIds: [] },
      discountItems: [],
      scheduleDiscountKind: "simple",
      buyXGetYPercentOff: {
        tiers: [{ minBuyQty: 2, discountPercentage: 10 }],
      },
    },
  });
  const { push } = useRouter();
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: async (data: DiscountFormData) => {
      await discountCore.createDiscount(data);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["scheduleDiscounts"] });
      push("/scheduleDiscounts");
    },
  });

  return (
    <Layout title={t(msg.discount.addScheduleDiscount)}>
      <ScheduleDiscountEditor methods={methods} mutation={mutation} btnText={t(msg.form.add)} />
    </Layout>
  );
}
